import { Skeleton } from '@/_components';
import { StickyPageHeaderSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeleton />

      <div className="flex max-w-full items-center justify-center px-8 py-60">
        <div className="flex max-w-full flex-col gap-y-4">
          <Skeleton className="h-[1.875rem] w-96 max-w-full" />
          <Skeleton className="h-[1.875rem] w-96 max-w-full" />
          <Skeleton className="h-[1.875rem] w-96 max-w-full" />
          <Skeleton className="h-[1.875rem] w-80 max-w-full" />
        </div>
      </div>
    </>
  );
}
